import { useState } from 'react'
import { setDomainStatuses } from 'features/report/reportAddSlice'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import NoneAnchor from 'components/NoneAnchor'
import CheckBox from 'components/form/CheckBox'
import { getDomainText } from 'features/report/common/DomainText'
import useOutsideClick from '../../../utils/hooks/useOutsideClick'

const DomainStatusFilter = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const ref = useOutsideClick(() => setVisible(false))
  const { domain, domainStatuses } = useSelector(
    state => state.report.reportAdd.formValues
  )
  const domainText = getDomainText(domain)
  return (
    <div ref={ref} className="single_wrap">
      <div
        className={classNames('opt_select opt_state ', {
          opt_open: visible,
          in_active: domain === 'account',
        })}>
        <div className="screen_out">데이터종류 선택상자</div>
        <span className="screen_out">선택내용 : </span>
        <NoneAnchor
          className="link_selected"
          onClick={() => setVisible(prev => !prev)}>
          {domainStatuses.includes('ON') &&
          domainStatuses.includes('OFF') &&
          domainStatuses.includes('DELETED')
            ? '상태 : 전체'
            : '사용자 설정'}
        </NoneAnchor>
        <span className="ico_arr" />
        <div className="screen_out">선택옵션</div>
        <div className="opt_list">
          <ul className="list_opt">
            <li className={classNames({ on: domainStatuses.includes('ON') })}>
              <CheckBox
                label="ON"
                tiaraAction={`보고서_${domainText}_상태_ON_클릭`}
                checked={domainStatuses.includes('ON')}
                onChange={() => dispatch(setDomainStatuses('ON'))}
              />
            </li>
            <li className={classNames({ on: domainStatuses.includes('OFF') })}>
              <CheckBox
                label="OFF"
                tiaraAction={`보고서_${domainText}_상태_OFF_클릭`}
                checked={domainStatuses.includes('OFF')}
                onChange={() => dispatch(setDomainStatuses('OFF'))}
              />
            </li>
            <li
              className={classNames({
                on: domainStatuses.includes('DELETED'),
              })}>
              <CheckBox
                label="삭제"
                tiaraAction={`보고서_${domainText}_상태_삭제_클릭`}
                checked={domainStatuses.includes('DELETED')}
                onChange={() => dispatch(setDomainStatuses('DELETED'))}
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default DomainStatusFilter
